export { default } from './TncModal';
